<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">Dashboard</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li aria-current="page" class="breadcrumb-item active">Library</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                        <div class="m-r-10">
                            <div class="lastmonth"></div>
                        </div>
                        <div class="">
                            <small>LAST YEAR</small>
                            <h4 class="text-info m-b-0 font-medium" v-if="sales">{{sales | money}}</h4>
                            <h4 class="text-info m-b-0 font-medium" v-if="!sales">0.00</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <!-- Column -->
                <div class="col-sm-12 col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Sales</h4>
                            <h5 class="card-subtitle">Total Sales this year</h5>
                            <h2 class="font-medium" v-if="sales">{{sales | money}}</h2>
                            <h2 class="font-medium" v-if="!sales">0.00</h2>
                        </div>
                        <div class="earningsbox m-t-5" style="height:78px; width:100%;"></div>
                    </div>
                </div>

                <!-- Column -->
                <div class="col-sm-12 col-lg-8">
                    <div class="card">
                        <div class="card-body border-bottom">
                            <h4 class="card-title">{{ $t('Dashboard.Overview') }}</h4>
                            <h5 class="card-subtitle">Overview for the year</h5>
                        </div>
                        <div class="card-body">
                            <div class="row m-t-10">
                                <div class="col-md-6 col-sm-12 col-lg-4">
                                    <div class="d-flex align-items-center">
                                        <div class="m-r-10"><span class="text-light-green display-4"><i class="mdi mdi-chart-areaspline"></i></span></div>
                                        <div><span class="text-muted">Net Profit</span>
                                            <h3 class="font-medium m-b-0">{{profit | money}}</h3></div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12 col-lg-4">
                                    <div class="d-flex align-items-center">
                                        <div class="m-r-10"><span class="text-orange display-4"><i class="mdi mdi-basket"></i></span></div>
                                        <div><span class="text-muted">Stock In Hand</span>
                                            <h3 class="font-medium m-b-0">{{stock}}</h3></div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12 col-lg-4">
                                    <div class="d-flex align-items-center">
                                        <div class="m-r-10"><span class="display-4"><i class="mdi mdi-credit-card"></i></span></div>
                                        <div><span class="text-muted">Purchases</span>
                                            <h3 class="font-medium m-b-0" v-if="purchases">{{purchases | money}}</h3>
                                            <h3 class="font-medium m-b-0" v-if="!purchases">0.00</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "CoopDashboard",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                chart: {},
                stock: '',
                sales: '',
                purchases: '',
                profit: ''
            }
        },
        mounted() {
            this.stockInHand();
            this.totalSales();
            this.totalPurchases();
            this.netProfit();
        },
        ready: function() {
            window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy: function() {
            window.removeEventListener('resize', this.handleResize)
        },
        methods: {
            handleResize() {
                this.handler.$emit('dispatch', () => this.$chartist.draw())
            },
            async stockInHand() {
                try {
                    let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/stock`);
                    this.stock   = response.data.stock;
                    console.log('stock in hand', response.data);
                } catch(e) {
                    this.$toastr('error', 'Failed to fetch stock summary', 'Failed')
                }
            },
            async totalSales() {
                try {
                    let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/totalSales`);
                    this.sales   = response.data;
                    console.log('sales', response.data);
                } catch(e) {
                    this.$toastr('error', 'Failed to fetch sales summary', 'Failed')
                }
            },
            async totalPurchases() {
                try {
                    let response   = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/totalPurchases`);
                    this.purchases = response.data;
                    console.log('purchases', response.data);
                } catch(e) {
                    this.$toastr('error', 'Failed to fetch purchases summary', 'Failed')
                }
            },
            async netProfit() {
                try {
                    let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/totalProfit`);
                    this.profit  = response.data;
                    console.log('net profit', response.data);
                } catch(e) {
                    this.$toastr('error', 'Failed to fetch profit summary', 'Failed')
                }
            }
        }
    }
</script>

<style scoped>

</style>
